import {useStore} from '../../../core/store';
import React, {FC, useCallback, useEffect, useRef, useState} from 'react';
import {useHistory, useParams} from 'react-router-dom';
import {SimpleTarget} from '../simple-target/simple-target';
import {Position2D} from '../simple-target/simple-target-interfaces';
import SendIcon from '@material-ui/icons/Send';

import {observer} from 'mobx-react-lite';
import {Button, FormControl, InputLabel, makeStyles, MenuItem, Select} from '@material-ui/core';
import {GameModel2} from '../../../core/interfaces';
import WinScreen from '../game-win-screen/game-win-screen';
import {DEFAULT_MELODY_DURATION} from '../../../core/constants';
import AddIcon from "@material-ui/icons/Add";
import classNames from "classnames";

interface GameOneCLickRouterParams {
    id: string;
}

const useComponentStyles = makeStyles({
    rootWrapper: {
        display: 'flex',
        alignItems: 'center',
    },
    game: {
        backgroundColor: '#fdfaf2',
    },
    infoWrapper: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        paddingBottom: '40px',
    },
    preview: {
        height: '400px',
        borderRadius: '50px',
        marginBottom: '40px',
        marginTop: '40px',
    },
    playButton: {
        fontSize: '140%',
    },
    playButtonText: {
        padding: '10px',
    }
});

let afterHitTimeoutID: ReturnType<typeof setTimeout>;

export const GameOne3CLick: FC = observer(() => {
        const {id} = useParams<GameOneCLickRouterParams>();
        const componentClasses = useComponentStyles();
        const store = useStore();
        const game = store.games3.find((game) => game.id === id);
        const history = useHistory();
        const gameEl = useRef<HTMLDivElement>(null);
        const [isInGamePlayMode, setGamePlayMode] = useState(false);
        const [showWinScreen, setShowWinScreen] = useState(false);
        const [selectedImage, setSelectedImage] = useState(null);
        const [timeSelectedImage, setTimeSelectedImage] = useState(null);
        const [audio, setAudio] = useState(new Audio('/assets/example.mp3'));

        const [data, setData] = useState({
            type: 1,
            time: 2,
            color: null,
            color2: null,
            start: false,
            screens: [],
            interval: null
        });

        function shuffleArray(array) {
            for (let i = array.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [array[i], array[j]] = [array[j], array[i]];
            }
        }

        useEffect(() => {
            if (game) {
                setData({...data, screens: game.screens})
            }
        }, [game]);


        useEffect(() => {

            const gameDOMEl = gameEl.current;
            const handleFullscreenChange = (event) => {
                const isFullScreen = document.fullscreenElement === event.target;
                if (!isFullScreen) {
                    clearTimeout(afterHitTimeoutID);
                    if (data.start) {
                        resetGame()
                        setData({...data, screens: game.screens, start: false})
                    }
                }
                setGamePlayMode(isFullScreen);
                if (!isFullScreen) {
                    setShowWinScreen(false);

                }
            };
            gameDOMEl?.addEventListener("fullscreenchange", handleFullscreenChange);
            document.addEventListener('keydown', keydownListener);
            return () => {
                gameDOMEl?.removeEventListener("fullscreenchange", handleFullscreenChange);
                document.removeEventListener('keydown', keydownListener);
            }
        }, [data, selectedImage, timeSelectedImage, audio])

        function keydownListener(e) {
            if (game && !selectedImage) {
                if (e.keyCode == 32 || e.keyCode == 13) {
                    e.preventDefault()
                    if (e.keyCode == 32) {
                        if (data.type === 1) {
                            if (data.start) {
                                btn1Click()
                            }
                        }
                        if (data.type === 2) {
                            if (data.start) {
                                goNext()
                            }
                        }
                    }
                    if (e.keyCode == 13) {
                        if (data.type === 2) {
                            if (data.start) {
                                btn1Click()
                            }
                        }
                    }
                    // const field = e.keyCode == 32 ? 'picture' : 'picture2'
                    // startMusic(game[field])
                }
            }
            if (e.keyCode == 27) {
                e.preventDefault()
                console.log('27')
                if (data.start) {
                    // resetGame()
                    // setData({...data, screens: game.screens, start: false})
                }
            }
        }

        function startMusic(image) {
            const audio = new Audio(URL.createObjectURL(timeSelectedImage.audio))
            window.audio = audio
            setTimeout(() => {
                const wrap = document.querySelector('.game2-finish')
                if (wrap) {
                    wrap.classList.add('game2-finish--show')
                    window.audio.play();
                }
            }, 100)
        }

        let timeout = null

        function resetGame() {
            console.log('resetGame resetGame resetGame')
            clearTimeout(timeout)
            clearTimeout(timeout2)
            window.noInterval = true
            setSelectedImage(null)
            setTimeSelectedImage(null)
            if (window.audio) {
                window.audio.pause();
                window.audio.currentTime = 0;
            }

            setData({...data, screens: game.screens})

            const screens = []
            const shuffledArray = [...game.screens]
            shuffleArray(shuffledArray)
            for (let i = game.imageCountForPlay; i > 0; i--) {
                screens.push(shuffledArray[i - 1])
            }
            setData({...data, screens: screens, start: true})
        }

        const handleGameStart = async () => {
            const screens = []
            const shuffledArray = data.screens
            shuffleArray(shuffledArray)
            for (let i = game.imageCountForPlay; i > 0; i--) {
                screens.push(shuffledArray[i - 1])
            }
            setData({...data, screens: screens, start: true})
            console.log('game.imageCountForPlay', game.imageCountForPlay, screens)
            // await requestGameFullscreen();
        };
        useEffect(() => {
            clearTimeout(timeout)
            if (timeSelectedImage && data.type === 1 && !selectedImage) {
                timeout = setTimeout(() => {
                    if (!window.noInterval) {
                        let nextElIndex = data.screens.indexOf(timeSelectedImage)
                        if (nextElIndex !== -1) {
                            if (nextElIndex === data.screens.length - 1) nextElIndex = 0
                            else nextElIndex++
                            setTimeSelectedImage(data.screens[nextElIndex])
                            console.log('setTimeSelectedImage(data.screens[nextElIndex])', nextElIndex)
                        }
                    } else {
                        clearTimeout(timeout)
                    }

                }, data.time * 1000)
            } else {
                clearTimeout(timeout)
            }

        }, [timeSelectedImage, data, selectedImage])

        let timeout2 = null
        useEffect(() => {
            clearTimeout(timeout2)
            if (selectedImage && !window.noInterval) {
                timeout2 = setTimeout(() => {
                    if (!window.noInterval) {
                        if (window.audio) {
                            window.audio.pause();
                            window.audio.currentTime = 0;
                        }
                        resetGame()
                        console.log('timeout2 resetGame',)
                    } else {
                        clearTimeout(timeout2)
                    }
                }, (timeSelectedImage?.melodyDuration || DEFAULT_MELODY_DURATION) * 1000)
            } else {
                clearTimeout(timeout2)
            }

        }, [selectedImage, data, audio])


        const btn1Click = () => {
            if (timeSelectedImage) {
                setSelectedImage(timeSelectedImage)
                startMusic()
            } else {
                window.noInterval = false
                setTimeSelectedImage(data.screens[0])
            }
        }

        const goNext = () => {
            if (!timeSelectedImage) {
                setTimeSelectedImage(data.screens[0])
            } else {
                let nextElIndex = data.screens.indexOf(timeSelectedImage)
                if (nextElIndex !== -1) {
                    if (nextElIndex === data.screens.length - 1) nextElIndex = 0
                    else nextElIndex++
                    setTimeSelectedImage(data.screens[nextElIndex])
                }
            }

        }

        const requestGameFullscreen = () => gameEl.current?.requestFullscreen();

        return (
            <div className={`users-game-3 ${componentClasses.rootWrapper}`}>
                {!game && <div>Игра не найдена</div>}
                {game && !data.start &&
                <div className={componentClasses.infoWrapper}>
                  <h1>{game.title}</h1>
                  <div className='form-group'>
                    <FormControl>
                      <InputLabel htmlFor="name-native-disabled">Тип доступа к игре</InputLabel>
                      <Select
                        value={data.type}
                        onChange={e => setData({...data, type: e.target.value})}
                      >
                        <MenuItem value={1}>1 кнопка</MenuItem>
                        <MenuItem value={2}>2 кнопки</MenuItem>
                      </Select>
                    </FormControl>
                      {data.type === 1 && <FormControl>
                        <InputLabel htmlFor="name-native-disabled">Время задержки (секунды)</InputLabel>
                        <Select
                          value={data.time}
                          onChange={e => setData({...data, time: e.target.value})}
                        >
                          <MenuItem value={0.5}>0.5</MenuItem>
                          <MenuItem value={1}>1</MenuItem>
                          <MenuItem value={1.5}>1.5</MenuItem>
                          <MenuItem value={2}>2</MenuItem>
                          <MenuItem value={2.5}>2.5</MenuItem>
                          <MenuItem value={3}>3</MenuItem>
                          <MenuItem value={3.5}>3.5</MenuItem>
                          <MenuItem value={4}>4</MenuItem>
                          <MenuItem value={4.5}>4.5</MenuItem>
                          <MenuItem value={5}>5</MenuItem>
                          <MenuItem value={5.5}>5.5</MenuItem>
                          <MenuItem value={6}>6</MenuItem>
                          <MenuItem value={6.5}>6.5</MenuItem>
                          <MenuItem value={7}>7</MenuItem>
                          <MenuItem value={7.5}>7.5</MenuItem>
                          <MenuItem value={8}>8</MenuItem>
                          <MenuItem value={8.5}>8.5</MenuItem>
                          <MenuItem value={9}>9</MenuItem>
                          <MenuItem value={9.5}>9.5</MenuItem>
                          <MenuItem value={10}>10</MenuItem>
                        </Select>

                      </FormControl>}

                    <FormControl>
                        {data.type === 1 && <InputLabel htmlFor="name-native-disabled">Цвет кнопки</InputLabel>}
                        {data.type === 2 && <InputLabel htmlFor="name-native-disabled">Цвет левой кнопки</InputLabel>}
                      <Select
                        value={data.color}
                        onChange={e => setData({...data, color: e.target.value})}
                      >
                        <MenuItem value={null}>нет</MenuItem>
                        <MenuItem value={'#f44336'}>красный</MenuItem>
                        <MenuItem value={'#03a9f4'}>синий</MenuItem>
                        <MenuItem value={'#ffc107'}>жёлтый</MenuItem>
                        <MenuItem value={'#4caf50'}>зелёный</MenuItem>
                        <MenuItem value={'#ff9800'}>оранжевый</MenuItem>
                        <MenuItem value={'#ffcdd2'}>розовый</MenuItem>
                      </Select>
                    </FormControl>

                      {data.type === 2 && <FormControl>
                        <InputLabel htmlFor="name-native-disabled">Цвет правой кнопки</InputLabel>
                        <Select
                          value={data.color2}
                          onChange={e => setData({...data, color2: e.target.value})}
                        >
                          <MenuItem value={null}>нет</MenuItem>
                          <MenuItem value={'#f44336'}>красный</MenuItem>
                          <MenuItem value={'#03a9f4'}>синий</MenuItem>
                          <MenuItem value={'#ffc107'}>жёлтый</MenuItem>
                          <MenuItem value={'#4caf50'}>зелёный</MenuItem>
                          <MenuItem value={'#ff9800'}>оранжевый</MenuItem>
                          <MenuItem value={'#ffcdd2'}>розовый</MenuItem>
                        </Select>
                      </FormControl>}
                  </div>
                  <img src={URL.createObjectURL(game.screens[0].picture)} className={componentClasses.preview}
                       alt="Превью игры"></img>
                  <Button onClick={handleGameStart} className={componentClasses.playButton} variant="contained"
                          color="primary">
                    <span className={componentClasses.playButtonText}>Играть</span><SendIcon/>
                  </Button>
                </div>
                }
                <div className={componentClasses.game} ref={gameEl}>
                    <div className="makeStyles-main-1">
                        {
                            data.start && game &&
                            <>
                                {game.showExitBtn && <Button
                                  onClick={() => {
                                      resetGame();
                                      history.push('/')
                                  }}
                                  className='exit-btn'
                                  variant="contained" color="primary" size="large">
                                  Выход
                                </Button>}
                                {game?.darkMode &&
                                <div className="game-background game-background--fixed game-background--dark"></div>}
                              <div className="game3">
                                <a className="game3__link-back" onClick={() => {
                                    clearTimeout(timeout2)
                                    clearTimeout(timeout)
                                    resetGame()
                                    setTimeSelectedImage(null)
                                    setSelectedImage(null)
                                    setData({...data, screens: game.screens, start: false})
                                    document.exitFullscreen()

                                }}>назад</a>
                                <div className="game3__container">
                                    {data.screens.map(i => {
                                        return <div className={classNames({
                                            "game3__btn": true,
                                            "game3__btn--selected": timeSelectedImage === i,
                                        })}>
                                            <img src={URL.createObjectURL(i.picture)} alt="Картинка"/>
                                        </div>
                                    })}
                                </div>
                                  {data.type === 1 && data.color && <div className="game3__btns">
                                    <Button
                                      onClick={btn1Click}
                                      style={{backgroundColor: data.color}}
                                      variant="contained" color="primary" size="large">
                                      кнопка
                                    </Button>
                                  </div>}
                                  {data.type === 2 && <div className="game3__btns">
                                    <Button
                                      onClick={goNext}
                                      style={{backgroundColor: data.color2}}
                                      variant="contained" color="primary" size="large">
                                      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
                                           fill="#fff"
                                           version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 297.5 297.5"
                                           style={{'enableBackground': 'new 0 0 47 47'}} xmlSpace="preserve">
                                        <polygon
                                          points="297.5,148.25 148,33.25 148,100.25 0,100.25 0,199.25 148,199.25 148,264.25 "/>
                                      </svg>
                                    </Button>
                                    <Button
                                      onClick={btn1Click}
                                      style={{backgroundColor: data.color}}
                                      variant="contained" color="primary" size="large">
                                      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
                                           fill="#fff"
                                           version="1.1" id="Capa_1" x="0px" y="0px" width="47px" height="47px"
                                           viewBox="0 0 47 47" style={{'enableBackground': 'new 0 0 47 47'}}
                                           xmlSpace="preserve">
                                        <g>
                                          <g id="Layer_1_27_">
                                            <g>
                                              <path
                                                d="M44.732,23.195l-4.528-0.001c-1.25,0.001-2.265,1.014-2.267,2.264v19.164c0,1.252,1.017,2.266,2.267,2.266h4.528     c1.252,0,2.268-1.014,2.268-2.266v-19.16C47,24.21,45.984,23.195,44.732,23.195z M42.927,44.521     c-0.726,0.727-1.903,0.727-2.629,0s-0.726-1.902,0-2.628c0.726-0.728,1.904-0.728,2.629,0     C43.652,42.618,43.652,43.794,42.927,44.521z"/>
                                              <path
                                                d="M29.078,9.795c0.197-2.889,0.969-4.351,1.238-7.204c0.154-1.626-1.549-2.479-4.647-2.479     c-3.098,0-4.298,2.773-4.648,3.718c-0.774,2.092,0,8.985,0,12.394c0,2.686-4.805,4.16-10.303,4.169C3.155,20.408,0,18.6,0,23.345     c0,1.642,1.013,2.973,2.265,2.972c-1.252,0-2.266,1.334-2.265,2.974c0,1.64,1.013,2.974,2.265,2.971     C1.013,32.264,0.001,33.595,0,35.233c0,1.645,1.015,2.973,2.265,2.975c-1.25-0.002-2.265,1.33-2.264,2.975     c0,1.643,1.013,2.972,2.264,2.972c0,0,3.219,0.003,15.429,0.003c12.21,0,16.671,0,16.671,0c0.625,0,1.131-0.507,1.132-1.134     V25.82c0.001-0.183-0.045-0.362-0.129-0.524C35.367,25.296,28.535,17.773,29.078,9.795z"/>
                                            </g>
                                          </g>
                                        </g>

                                      </svg>
                                    </Button>
                                  </div>}
                              </div>
                                {selectedImage &&
                                <div className={`game2-finish game-background ${game?.darkMode && 'game-background--dark '}`}
                                     onClick={() => resetGame()}>
                                  <img src={URL.createObjectURL(selectedImage.picture2)} alt="картинка"/>
                                </div>}
                            </>
                        }
                    </div>
                </div>
            </div>
        );
    }
)

export default GameOne3CLick;
